import { ZoomableImage } from "../utilities/zoomable-image.js";

export class Pathophysiology {
    constructor(parameters) {
        var t = this;

        // carousel functionality
        let slideIndex = 1,
            previousButton = document.getElementById("previous-btn"),
            nextButton = document.getElementById("next-btn"),
            slideButton1 = document.getElementById("slide-title-1"),
            slideButton2 = document.getElementById("slide-title-2"),
            slideButton3 = document.getElementById("slide-title-3"),
            slideButton4 = document.getElementById("slide-title-4"),
            slideButton5 = document.getElementById("slide-title-5");

        //show first slide
        showSlide(slideIndex);

        function moveSlide(n) {
            showSlide(slideIndex += n);
        }

        function currentSlide(n) {
            showSlide(slideIndex = n);
        }

        function showSlide(n) {
            let i,
                carousel = document.getElementById("desktop-carousel");
            var slides = carousel.querySelectorAll(".carousel-slide");
            var dots = carousel.querySelectorAll(".slide-title");
            if (n > slides.length) {
                slideIndex = 1;
            }
            if (n < 1) {
                slideIndex = slides.length;
            }
            for (i = 0; i < slides.length; i++) {
                slides[i].style.display = "none";
            }
            for (i = 0; i < dots.length; i++) {
                dots[i].className = dots[i].className.replace(" active", "");
            }

            slides[slideIndex - 1].style.display = "block";
            dots[slideIndex - 1].className += " active";
        }

        previousButton.addEventListener("click", function () {
            moveSlide(-1);
        });

        nextButton.addEventListener("click", function () {
            moveSlide(1);
        });

        slideButton1.addEventListener("click", function () {
            currentSlide(1);
        });

        slideButton2.addEventListener("click", function () {
            currentSlide(2);
        });

        slideButton3.addEventListener("click", function () {
            currentSlide(3);
        });

        slideButton4.addEventListener("click", function () {
            currentSlide(4);
        });

        slideButton5.addEventListener("click", function () {
            currentSlide(5);
        });


        // Setup enlargable images
        let enlargableImages = document.querySelectorAll(".enlargable-image");
        for (let i = 0; i < enlargableImages.length; i++)
            new ZoomableImage(enlargableImages[i]);


        // body with active spots 
        var hotspots = document.querySelectorAll('#hotspots .hotspot'),
            radioBttns = document.querySelectorAll('#body-content input[type="radio"]');
        // event listener for svg spots
        for (var h = 0; h < hotspots.length; h++) {
            let hotspot = hotspots[h];
            hotspot.addEventListener('click', function (event) {
                event.preventDefault();
                event.stopPropagation();

                var radio = this.getAttribute('data-radio');

                for (var s = 0; s < hotspots.length; s++) {
                    hotspots[s].classList.remove('active');
                }
                document.getElementById(radio).checked = true;
                this.classList.add('active');
            });
        }
        // event listener for radio buttons
        for (var r = 0; r < radioBttns.length; r++) {
            let radioBttn = radioBttns[r];

            radioBttn.addEventListener('change', function (event) {
                event.preventDefault();
                event.stopPropagation();

                var item = event.target.value;

                for (var s = 0; s < hotspots.length; s++) {
                    hotspots[s].classList.remove('active');
                }
                document.querySelector('.' + item).classList.add('active');

            });
        }
        document.addEventListener("DOMContentLoaded", function (event) {
            // reset body to first selection
            for (var s = 0; s < hotspots.length; s++) {
                hotspots[s].classList.remove('active');
            } 
            hotspots[0].classList.add('active');
            document.getElementById('neurological').checked = true;
        });

    }
}